/**
 * @generated SignedSource<<41a98fe02c3100ce14ecd2db5d085e22>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type genericRuleEditor_AIVirtualModelRuleCountQuery$variables = {
  id: string;
};
export type genericRuleEditor_AIVirtualModelRuleCountQuery$data = {
  readonly aiVirtualModelRule: {
    readonly productIDs: ReadonlyArray<number>;
  } | null;
};
export type genericRuleEditor_AIVirtualModelRuleCountQuery = {
  response: genericRuleEditor_AIVirtualModelRuleCountQuery$data;
  variables: genericRuleEditor_AIVirtualModelRuleCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productIDs",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "genericRuleEditor_AIVirtualModelRuleCountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AIVirtualModelRuleOutput",
        "kind": "LinkedField",
        "name": "aiVirtualModelRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "genericRuleEditor_AIVirtualModelRuleCountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AIVirtualModelRuleOutput",
        "kind": "LinkedField",
        "name": "aiVirtualModelRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5f6362c0623c52430896b89dce9a19e4",
    "id": null,
    "metadata": {},
    "name": "genericRuleEditor_AIVirtualModelRuleCountQuery",
    "operationKind": "query",
    "text": "query genericRuleEditor_AIVirtualModelRuleCountQuery(\n  $id: ID!\n) {\n  aiVirtualModelRule(id: $id) {\n    productIDs\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc00a330136c8705ec48c98bbf9cb4fd";

export default node;
